import { Box, Grid, Typography } from "@material-ui/core";
import { useNotify, useRedirect } from "ra-core";
import { ReferenceField, TextField } from "ra-ui-materialui";
import LeftGridEdit from "../components/LeftGridEdit";
import RightGridEdit from "../components/RightGridEdit";

import TextInputRA from "../components/TextInputRA";
import LayoutContainer from "../components/LayoutContainer";
import StatusInput from "../components/StatusInput";
import { makeStyles } from "@material-ui/styles";
import SubCategoryEditValidation from "../../../ValidationRules/SubCategoryEditValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import { Loading } from "react-admin";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";
const useStyles = makeStyles(() => ({
  row: {
    display: "grid",
    gridTemplateColumns: "150px auto",

    marginTop: 15,
    marginBottom: 15,
    alignItems: "center",
  },
}));

const transform = (data) => {
  return {
    ...data,
  };
};

const CategoryEdit = (props) => {
  const classes = useStyles();
  const notify = useNotify();
  const redirect = useRedirect();
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Category",
    write: true,
  });
  if (loading) return <Loading />;
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };
  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridEdit
          {...props}
          onSuccess={onSuccess}
          onFailure={onFailure}
          validate={SubCategoryEditValidation}
          transform={transform}
          disabled={!allow}
        >
          <SfBreadcrumbs path="Management/Sub-categories/Edit" />
          <Box style={{ margin: 50 }}>
            <TextInputRA required label="Subcategory name" source="name" />
            <TextInputRA label="Description" source="desc" />
            <Box className={classes.row}>
              <Typography style={{ fontSize: 16 }}>Category</Typography>
              <ReferenceField
                label="Category"
                source="category.id"
                reference="product-categories"
                link={false}
              >
                <TextField source="name" disabled />
              </ReferenceField>
            </Box>

            <StatusInput />
          </Box>
        </LeftGridEdit>
        <RightGridEdit {...props} noImage />
      </Grid>
      {/* <Edit
        mutationMode="pessimistic"
        onSuccess={onSuccess}
        onFailure={onFailure}
        {...props}
      >
        <SimpleForm>
          <TextInputRA label="Subcategory name" source="name" />
          <TextInputRA label="Description" source="desc" />
        </SimpleForm>
      </Edit> */}
    </LayoutContainer>
  );
};

export default CategoryEdit;
